<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>配置管理</el-breadcrumb-item>
      <el-breadcrumb-item>配置列表</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 卡片视图 -->
    <el-card>
      <el-row :gutter="10">
        <el-col :span="5">
        </el-col>
        <el-col :span="5">
          <el-button 
            type="primary" 
            @click="addDataInfoDialog"
            icon="el-icon-plus"
            >添加配置</el-button
          >
        </el-col>
      </el-row>


      <!-- 表格数据 -->
      <el-table :data="configInfoList" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="数据库名称" prop="dbName"></el-table-column>
        <el-table-column label="图片" prop="imgUrl">
          <template slot-scope="scope">
            <el-popover placement="right" width="300" trigger="hover">
              <img
                :src="COMMON_CONFIG.LOAD_IMG_URL + scope.row.imgUrl"
                height="300"
                width="300"
              />
              <img
                slot="reference"
                :src="COMMON_CONFIG.LOAD_IMG_URL + scope.row.imgUrl"
                height="50"
                width="50"
              />
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime" width="160px"></el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="修改"
              placement="top"
              :enterable="false"
            >
              <el-button
                type="primary"
                icon="el-icon-edit"
                size="mini"
                @click="showEditDialog(scope.row.id)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
              :enterable="false"
            >
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                @click="removeById(scope.row.id)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>


      <!-- 分页组件 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryParams.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="total"
      >
      </el-pagination>


      <!-- 添加配置 -->
      <el-dialog
        title="添加配置"
        :visible.sync="addDialogVisible"
        v-if="addDialogVisible"
        width="40%"
        @close="addDialogClosed"
        :append-to-body="true"
      >
        <el-form :model="addDataInfoForm" :rules="addRules" ref="addRoleRef">
          <el-form-item label="图片" label-width="120px">
                          <v-config-img-upload :defaultImgUrl="addDataInfoForm.imgUrl" @imgOnChange="addImgChange"
                              @imgOnRemove="addImgRemove">
                          </v-config-img-upload>
                      </el-form-item>
          <el-form-item label="数据库名称" label-width="120px" prop="dbName">
            <el-input
              autocomplete="off"
              v-model="addDataInfoForm.dbName"
              clearable
              placeholder="最多输入20个字"
            ></el-input>
          </el-form-item>
          <el-form-item label="数据库类型" label-width="120px" prop="dbType">
                <el-select
                  v-model="addDataInfoForm.dbType"
                  placeholder="请选择数据库类型"
                  clearable
                >
                <el-option label="智能家电" :value="1"></el-option>
                <el-option label="新一代信息技术" :value="2"></el-option>
                <el-option label="特色生物" :value="3"></el-option>
                <el-option label="现代农业与食品" :value="4"></el-option>
                </el-select>
              </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addDataInfoSubmit()">提 交</el-button>
        </span>
      </el-dialog>


      <!-- 修改配置 -->
      <el-dialog
        title="修改配置"
        :visible.sync="editDialogVisible"
        width="40%"
        v-if="editDialogVisible"
        @close="editDialogClosed"
      >
        <el-form :model="addDataInfoForm" :rules="addRules" ref="editRoleRef">
          <el-form-item label="图片" label-width="120px">
                        <v-config-img-upload :defaultImgUrl="addDataInfoForm.imgUrl" @imgOnChange="addImgChange"
                            @imgOnRemove="addImgRemove">
                        </v-config-img-upload>
                    </el-form-item>
          <el-form-item label="数据库名称" label-width="120px" prop="dbName">
            <el-input
              autocomplete="off"
              v-model="addDataInfoForm.dbName"
              clearable
              placeholder="最多输入20个字"
            ></el-input>
          </el-form-item>
          <el-form-item label="数据库类型" label-width="120px" prop="dbType">
                <el-select
                  v-model="addDataInfoForm.dbType"
                  placeholder="请选择数据库类型"
                  clearable
                >
                <el-option label="智能家电" :value="1"></el-option>
                <el-option label="新一代信息技术" :value="2"></el-option>
                <el-option label="特色生物" :value="3"></el-option>
                <el-option label="现代农业与食品" :value="4"></el-option>
                </el-select>
              </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="editDataInfoSubmit()">提 交</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import vConfigImgUpload from "./ConfigImgUpload.vue"
export default {
  components: {
    vConfigImgUpload
  },
  data() {
    return {
      addRules: {
        dbName: [
          { required: true, message: "请输入数据库名称", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "最多只能输入20个字",
            trigger: "blur",
          },
        ]
      },
      queryParams: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      addDataInfoForm: {
        dbName: "",
        dbType: 1,
        imgUrl: ""
      },
      configInfoList: [],
      addDialogVisible: false,
      editDialogVisible: false
    }
  },
  created() {
    this.getConfigList();
  },
  methods: {
    addDataInfoDialog() {
      this.addDialogVisible = true;
      this.addDataInfoForm = {
        dbName: "",
        dbType: 1,
        imgUrl: ""
      }
    },
    addImgChange(url) {
      this.addDataInfoForm.imgUrl = url;
    },
    addImgRemove() {
      this.addDataInfoForm.imgUrl = "";
    },
    addDialogClosed() {
      this.$refs.addRoleRef.resetFields();
    },
    editDialogClosed() {
      // this.$refs.editRoleRef.resetFields();
    },
    handleSizeChange(newSize) {
      this.queryParams.pageSize = newSize;
      this.getConfigList();
    },
    handleCurrentChange(newPage) {
      this.queryParams.pageNo = newPage;
      this.getConfigList();
    },
    async getConfigList() {
      const { data: res } = await this.$http.get("ptconfig/find/page", {
        params: this.queryParams,
      });
      if (res.code == 0) {
        this.configInfoList = res.data.list;
        this.total = res.data.total;
      } else {
        this.$message.error(res.msg);
      }
    },
    async showEditDialog(id) {
      const { data: res } = await this.$http.get("ptconfig/find/" + id);
      if (res.code == 0) {
        this.addDataInfoForm = res.data;
        this.editDialogVisible = true;
      } else {
        this.$message.error(res.msg);
      }
    },
    editDataInfoSubmit() {
      this.$refs.editRoleRef.validate(async (valid) => {
        if (valid) {
          const { data: res } = await this.$http.post(
            "ptconfig/update",
            this.addDataInfoForm
          );
          if (res.code == 0) {
            this.$message.success("修改成功");
            this.getConfigList();
          } else {
            this.$message.error(res.msg);
            return false;
          }
          this.editDialogVisible = false;
        } else {
          return false;
        }
      });
    },
    async removeById(id) {
      const confirmResult = await this.$confirm("是否确认删除该记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      // 点击确定 返回值为：confirm
      // 点击取消 返回值为： cancel
      if (confirmResult !== "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$http.delete("ptconfig/remove/" + id);
      if (res.code == 0) {
        this.$message.success("删除成功！");
        this.getConfigList();
      } else {
        return this.$message.error("删除失败！");
      }
    },
    addDataInfoSubmit() {
      this.$refs.addRoleRef.validate(async (valid) => {
        if (valid) {
          const { data: res } = await this.$http.post(
            "ptconfig/add",
            this.addDataInfoForm
          );
          if (res.code == 0) {
            this.$message.success("添加成功");
            this.getConfigList();
          } else {
            this.$message.error(res.msg);
            return false;
          }
          this.addDialogVisible = false;
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>

</style>